//
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "./Sidebar";
import { userApi, authApi } from "../../api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const VERIFICATION_COOLDOWN_KEY = "emailVerificationExpiresAt";


export default function AccountDetails({onLoaded}) {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        pass: "",
        newpass: "",
        confirmPassword: "",
        emailVerified: false,
        createdAt: "",
    });

    const [isSendingVerification, setIsSendingVerification] = useState(false);
    const [verificationCooldown, setVerificationCooldown] = useState(0);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const { data } = await userApi.getUser();
                const user = data.user;

                setFormData((prev) => ({
                    ...prev,
                    firstName: user.firstName || "",
                    lastName: user.lastName || "",
                    email: user.email || "",
                    phoneNumber: user.phoneNumber || "",
                    emailVerified: user.emailVerified,
                    createdAt: user.createdAt,
                }));
                onLoaded?.();

            } catch (error) {
            }
        };

        fetchUser();
    }, []);

    useEffect(() => {
        const storedExpiry = localStorage.getItem(VERIFICATION_COOLDOWN_KEY);
        if (!storedExpiry) return;

        const diffMs = Number(storedExpiry) - Date.now();
        if (diffMs > 0) {
            const diffSec = Math.floor(diffMs / 1000);
            setVerificationCooldown(diffSec);
        } else {
            localStorage.removeItem(VERIFICATION_COOLDOWN_KEY);
        }
    }, []);

    useEffect(() => {
        if (verificationCooldown <= 0) return;

        const interval = setInterval(() => {
            setVerificationCooldown((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);
                    localStorage.removeItem(VERIFICATION_COOLDOWN_KEY);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [verificationCooldown]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        const { firstName, lastName, email, phoneNumber, pass, newpass, confirmPassword } = formData;

        try {
            await userApi.updateUser({ firstName, lastName, email, phoneNumber });
            toast.success("Kullanıcı bilgileri güncellendi.");

            if (pass || newpass || confirmPassword) {
                if (!pass || !newpass || !confirmPassword) {
                    toast.warning("Tüm şifre alanlarını doldurun.");
                } else if (newpass !== confirmPassword) {
                    toast.error("Yeni şifreler uyuşmuyor.");
                } else {
                    await userApi.changePassword({
                        currentPassword: pass,
                        newPassword: newpass,
                        confirmPassword,
                    });
                    toast.success("Şifre başarıyla değiştirildi.");
                }

                // Şifre alanlarını sıfırla
                setFormData((prev) => ({
                    ...prev,
                    pass: "",
                    newpass: "",
                    confirmPassword: "",
                }));
            }
        } catch (error) {
            console.error("Güncelleme hatası:", error);
            toast.error("Bir hata oluştu. Lütfen tekrar deneyin.");
        }
    };

    const handleSendVerification = async () => {
        if (formData.emailVerified) return;
        if (verificationCooldown > 0 || isSendingVerification) return;

        try {
            setIsSendingVerification(true);

            // Backend çağrısı
            const res = await authApi.sendEmailVerification();

            // Backend success cevabı buradan alınır
            if (res?.data?.message === "Verification email has been sent.") {
                toast.success("Verification email has been sent.");

                // 5 dakikalık cooldown
                const cooldownSeconds = 5 * 60;
                const expiresAt = Date.now() + cooldownSeconds * 1000;

                localStorage.setItem(VERIFICATION_COOLDOWN_KEY, String(expiresAt));
                setVerificationCooldown(cooldownSeconds);
            } else {
                toast.error("Unexpected response from server.");
            }

        } catch (error) {
            console.error(error);
            toast.error(
                error?.response?.data?.message ||
                "Email could not be sent. Try again."
            );

        } finally {
            // Spinner burada durur
            setIsSendingVerification(false);
        }
    };



    const formatCooldown = (seconds) => {
        const m = String(Math.floor(seconds / 60)).padStart(2, "0");
        const s = String(seconds % 60).padStart(2, "0");
        return `${m}:${s}`;
    };


    return (
        <div className="main-content-account">
            {/* Breadcrumb */}
            <div className="tf-breadcrumb">
                <div className="container">
                    <ul className="breadcrumb-list">
                        <li className="item-breadcrumb">
                            <Link to={`/`} className="text">Home</Link>
                        </li>
                        <li className="item-breadcrumb dot"><span /></li>
                        <li className="item-breadcrumb">
                            <span className="text">Account Detail</span>
                        </li>
                    </ul>
                </div>
            </div>

            {/* Title */}
            <section className="s-title-page">
                <div className="container">
                    <h4 className="s-title letter-0 text-center">My Account Details</h4>
                </div>
            </section>

            {/* Sidebar + Form */}
            <section className="s-account flat-spacing-17">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="my-account-container input-page">
                                <div className="sidebar-account-wrap sidebar-content-wrap sticky-top d-lg-block d-none">
                                    <ul className="my-account-nav">
                                        <Sidebar />
                                    </ul>
                                </div>

                                <div className="my-acount-content account-dashboard">
                                    <form onSubmit={handleSubmit} className="form-edit-account">
                                        <h6 className="display-xs title-form">Account Details</h6>

                                        <div className="form-name">
                                            <div className="tf-field style-2 style-3">
                                                <input
                                                    className="tf-field-input tf-input"
                                                    id="firstname"
                                                    placeholder=" "
                                                    type="text"
                                                    name="firstName"
                                                    value={formData.firstName}
                                                    onChange={handleChange}
                                                />
                                                <label className="tf-field-label" htmlFor="firstname">First name</label>
                                            </div>

                                            <div className="tf-field style-2 style-3">
                                                <input
                                                    className="tf-field-input tf-input"
                                                    id="lastname"
                                                    placeholder=" "
                                                    type="text"
                                                    name="lastName"
                                                    value={formData.lastName}
                                                    onChange={handleChange}
                                                />
                                                <label className="tf-field-label" htmlFor="lastname">Last name</label>
                                            </div>

                                            <div className="tf-field style-2 style-3">
                                                <input
                                                    className="tf-field-input tf-input"
                                                    id="email"
                                                    placeholder=" "
                                                    type="email"
                                                    name="email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                />
                                                <label className="tf-field-label" htmlFor="email">Email</label>
                                            </div>

                                            <div className="tf-field style-2 style-3">
                                                <input
                                                    className="tf-field-input tf-input"
                                                    id="phoneNumber"
                                                    placeholder=" "
                                                    type="text"
                                                    name="phoneNumber"
                                                    value={formData.phoneNumber}
                                                    onChange={handleChange}
                                                />
                                                <label className="tf-field-label" htmlFor="phoneNumber">Phone
                                                    Number</label>
                                            </div>

                                            <div className="user-info-box-2">
                                                <div className="info-left">
                                                    <span className="label">Member Since:</span>
                                                    <span className="value">
                                                      {new Date(formData.createdAt).toLocaleDateString("en-GB")}
                                                    </span>
                                                </div>



                                                <div className="info-right">
                                                    <span className="label">Email Verified:</span>
                                                    <span className="value">
                                                        {formData.emailVerified ? (
                                                            <span className="icon-check"></span>
                                                        ) : (
                                                            <span className="icon-cross">✖</span>
                                                        )}
                                                    </span>

                                                </div>
                                            </div>

                                            {!formData.emailVerified && (
                                                <button
                                                    type="button"
                                                    className="tf-btn tf-btn-sm animate-btn"
                                                    onClick={handleSendVerification}
                                                    disabled={isSendingVerification || verificationCooldown > 0}
                                                >
                                                    {isSendingVerification ? (
                                                        <>
                                                <span
                                                    className="spinner-border spinner-border-sm me-2"
                                                    role="status"
                                                    aria-hidden="true"
                                                ></span>
                                                            Sending...
                                                        </>
                                                    ) : verificationCooldown > 0 ? (
                                                        <>Resend in {formatCooldown(verificationCooldown)}</>
                                                    ) : (
                                                        <>Send Verification Email</>
                                                    )}
                                                </button>
                                            )}


                                        </div>

                                        <div className="form-pass">
                                            <div className="text-lg title-pass mt-3 mb-2">Password Change</div>

                                            <div className="tf-field style-2 style-3">
                                                <input
                                                    className="tf-field-input tf-input"
                                                    id="pass"
                                                    placeholder=" "
                                                    type="password"
                                                    name="pass"
                                                    value={formData.pass}
                                                    onChange={handleChange}
                                                />
                                                <label className="tf-field-label" htmlFor="pass">Current password</label>
                                            </div>

                                            <div className="tf-field style-2 style-3">
                                                <input
                                                    className="tf-field-input tf-input"
                                                    id="newpass"
                                                    placeholder=" "
                                                    type="password"
                                                    name="newpass"
                                                    value={formData.newpass}
                                                    onChange={handleChange}
                                                />
                                                <label className="tf-field-label" htmlFor="newpass">New password</label>
                                            </div>

                                            <div className="tf-field style-2 style-3">
                                                <input
                                                    className="tf-field-input tf-input"
                                                    id="confirmPassword"
                                                    placeholder=" "
                                                    type="password"
                                                    name="confirmPassword"
                                                    value={formData.confirmPassword}
                                                    onChange={handleChange}
                                                />
                                                <label className="tf-field-label" htmlFor="confirmPassword">Confirm password</label>
                                            </div>
                                        </div>

                                        <button type="submit" className="tf-btn animate-btn">Save Changes</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
